import { GridColDef, getGridDateOperators } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { DAYJS_VISUALIZATION_DATE_FORMAT } from '../../utils/date';
import FilterDatePicker from './FilterDatePicker';

export const getGridDateColDef = (): Pick<
  GridColDef,
  'type' | 'valueGetter' | 'valueFormatter' | 'filterOperators'
> => ({
  type: 'date',
  valueGetter: dateProp => new Date(dateProp),
  valueFormatter: value => dayjs(value).format(DAYJS_VISUALIZATION_DATE_FORMAT),
  filterOperators: getGridDateOperators()
    .filter(operator => !['isEmpty', 'isNotEmpty'].includes(operator.value))
    .map(operator => ({ ...operator, InputComponent: FilterDatePicker })),
});
